import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { RentalReservationActivityEventHydration } from './rental-reservation-activity-event-hydration.dto';

/**
 * A rental reservation activity event with hydrated related records.
 */
export class RentalReservationActivityEventDto extends ActivityEventDto {
  hydrated?: RentalReservationActivityEventHydration;
}
